export const getColumns = (t) => {
	return [
		{
			label: t("name_and_surname"),
			name: "name",
		},
		{ label: t("entered"), name: "entered" },
		{ label: t("sold"), name: "sold" },
		{ label: t("unsold_1"), name: "notSold" },
		{
			label: t("income") + " (€)",
			name: "income",
			options: {
				customBodyRender: (value) => {
					return Math.floor(value);
				},
			},
		},
		{
			label: t("average_margin") + " (€)",
			name: "avgMargin",
			options: {
				customBodyRender: (value) => {
					return Math.floor(value);
				},
			},
		},
		{
			label: t("total_margin") + " (€)",
			name: "margin",
			options: {
				customBodyRender: (value) => {
					return Math.floor(value);
				},
			},
		},
		{ label: t("result_in_organization"), name: "place" },
	];
};

export const getOptions = (t) => {
	return {
		searchOpen: true,
		search: false,
		searchAlwaysOpen: true,
		searchPlaceholder: t("search"),
		filter: false,
		download: true,
		viewColumns: false,
		selectableRows: "none",
		print: false,
		rowsPerPageOptions: [10, 20, 50, 100],
		rowsPerPage: 20,
		textLabels: {
			pagination: {
				next: t("next_page"),
				previous: t("previous_page"),
				rowsPerPage: t("rows_per_page"),
				displayRows: t("of"),
			},
			toolbar: {
				search: t("search"),
				downloadCsv: t("download_csv"),
				print: t("print"),
				viewColumns: t("select_columns"),
				filterTable: t("filters"),
			},
			filter: {
				title: t("filters"),
				reset: t("reset"),
				all: t("all"),
			},
			viewColumns: {
				title: t("show_columns"),
			},
			selectedRows: {
				text: t("removed_rows"),
				delete: t("remove"),
			},
			body: {
				noMatch: t("no_matching_data_found"),
			},
		},
	};
};
